// Pure WhatsApp phone rule, mirrored by public.comm_normalize_phone and src/lib/comm/phone.ts.
// Returns 55 + DDD + number (mobiles always with the 9), or null when invalid or a filler
// number (every local digit equal, ignoring the leading mobile 9).
export const INVALID_WHATSAPP_MESSAGE = 'Informe um WhatsApp válido com DDD';

export function normalizeWhatsAppPhone(p?: string | null): string | null {
  if (!p) return null;
  let d = String(p).replace(/\D/g, '');
  if (d.length === 10 || d.length === 11) d = '55' + d;
  else if (!((d.length === 12 || d.length === 13) && d.startsWith('55'))) return null;
  if (d.length === 12 && '6789'.includes(d[4])) d = d.slice(0, 4) + '9' + d.slice(4);
  let local = d.slice(4);
  if (local.length === 9 && local[0] === '9') local = local.slice(1);
  if (/^(\d)\1*$/.test(local)) return null;
  return d;
}

export const isValidWhatsAppPhone = (p?: string | null) => normalizeWhatsAppPhone(p) !== null;
